import { defaultDougnutDatasetOptions, defaultDougnutOptions, getColors } from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {DoughnutChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'sales_property_type',
    resource: {
      endpoint: 'total_by_propertytype',
      filter: {
        'filter.statuses': ['sold', 'reserved', 'sale'],
      },
    },
    type: 'Doughnut',
    title: {
      label: `${context.$t('statisticsSalesResidentials')} ${context.$t('propertyType').toLowerCase()}`,
      style: true,
    },
    total: ({ data = {} }) => ({
      heading: context.valueParser(data.total, { notation: 'compact' }),
    }),
    data: props => {
      const { data = {}, dimensions = [], colors = {} } = props
      if (!data || !data.values) return {}
      return {
        labels: dimensions.map(dimension => dimension.label),
        datasets: [
          {
            ...defaultDougnutDatasetOptions,
            backgroundColor: data && data.keys ? data.keys.map(key => colors[key]) : [],
            data: data.values || [],
          },
        ],
      }
    },
    options: defaultDougnutOptions,
    colors: ({ data }) => getColors(data.keys, true),
    dimensions: ({ data = {}, colors = {} }) =>
      data && data.keys
        ? data.keys.map((key, i) => ({
            id: key,
            label: context.getTranslation(key),
            value: context.valueParser(data.values[i], { notation: 'compact' }),
            marker: colors[key],
          }))
        : [],
    heading: {
      label: context.$t('propertyType'),
      style: '',
    },
  }
}
